import { ReactNode } from "react";
import { useAuthStore } from "@/store/authStore";
import type { Permission } from "@/utils/permissions";

interface PermissionGateProps {
  required: Permission | Permission[];
  children: ReactNode;
  fallback?: ReactNode;
}

export function PermissionGate({ required, children, fallback }: PermissionGateProps) {
  const permissions = useAuthStore((s) => s.user?.permissions ?? []);
  const requiredList = Array.isArray(required) ? required : [required];
  const hasAll = requiredList.every((p) => permissions.includes(p));

  if (!hasAll) return <>{fallback || null}</>;

  return <>{children}</>;
}
